import { useCapability } from "hooks/capabilities";
import { useAppSelector } from "hooks/redux_hooks";
import { CapabilityType } from "shared/types";
import { classroomSelectors } from "store";

function ExternalResourceWarning() {
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);
  const hasPresentationView = useAppSelector(classroomSelectors.selectHasPresentationView());
  const isPresentationView = useAppSelector(classroomSelectors.selectIsPresentationView());

  if (!canControlClassroom || !hasPresentationView || isPresentationView) return null;

  return (
    <div className="flex items-center justify-center border-box px2 py1 center bg-black-tint-20 text-black-tint-90 h6">
      <div>Scroll or zoom the Presentation View to change how the resource is displayed.</div>
    </div>
  );
}

export { ExternalResourceWarning };
